import React, {Component} from 'react';
import {
    View,
    StatusBar,
    Image,
    TextInput,

    BackHandler,
    Alert,
    TouchableOpacity,
    Platform,
    KeyboardAvoidingView,
    FlatList, ActivityIndicator, ScrollView, StyleSheet,
    Text
} from "react-native"
import {verticalScale, moderateScale, scale} from "../../../../tools/Scaling";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import i18n from "../../../../I18n/i18n";
import store from "../../../../redux/store";
import {typeExport} from "../../../../redux/store/type";
//import Modal from "react-native-modal";
import ImagePicker from "react-native-image-crop-picker";
import axios from "axios";
import HMSelectInput from "../../../../customviews/HMSelectInput";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMIcon from "../../../../customviews/HMIcon";
import HMLightbox from "../../../../customviews/lightbox/HMLightbox";
import HMModal from "../../../../customviews/modal/HMModal";
import {Tools} from "../../../../tools/Tools";
import HMAlert from "../../../../customviews/HMAlert";

let container = null;
export default class UploadDocumentSatiaScreen extends Component {
    constructor(props) {
        super(props);
        container = this;
        this.state = {
            visibleModal: false,
            once: true,
            listImage: [],
            TypeDocumentsList: [],

        }

    }

    componentWillMount() {
        this.getData()
    }

    componentWillReceiveProps(props) {
        if (this.state.OneDo && props.results) {
            this.setState({
                OneDo: false,
                listImage: props.results,
            })
        }
    }


    getData() {
        this.setState({
                OneDo: true
            },
            () => {
                let paramss = {
                    "lang": i18n.locale,
                    "token": store.getState().reducerSplashSatiaScreen.token,
                    //"token_fb": this.props.DataSplashScreen.token_fb,

                };
                this.props.callService(
                    typeExport.urlUploadDocumentSatiaScreen,
                    //`?token=${this.state.token}&name=${this.state.name.value}&LastName=${this.state.LastName.value}`,
                    //  `?name=${this.state.FirstName.value}&family=${this.state.LastName.value}`,
                    paramss,
                    typeExport.TypeGetUploadDocumentSatiaScreen,
                    "POST",
                    this.props.token
                );
            }
        )

    }


    render() {
        let {item} = this.props.route.params

        return (
            <View style={{position: 'relative', flex: 1}}>
                {/*<HMImageBackground/>*/}
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <View style={{flex: 1,}}>
                            <HMActionBarSatia
                                props={this.props} statusBarTransparent
                                text={(item.name ? item.name : (item.title ? item.title : ''))}

                                //  text={i18n.t('constant.Information')}

                                menu
                                back
                                headerVisibility more_menu
                                onBackPress={() => this.props.navigation.pop()}

                            />
                            {
                                this.state.listImage.length > 0 ?
                                    <FlatList
                                        style={{marginTop: moderateScale(6)}}
                                        //  listKey={(item, index) => 'D' + index.toString()}

                                        // numColumns={4}
                                        /*      data={[
                                                  {id: 1, type: 1, name: 'بزرگ'},
                                                  {id: 1, type: 1, name: 'کوچک'}, {id: 1, type: 1, name: 'بزرگ'},
                                                  {id: 1, type: 1, name: 'کوچک'}, {id: 1, type: 1, name: 'بزرگ'},
                                                  {id: 1, type: 1, name: 'کوچک'}, {id: 1, type: 1, name: 'بزرگ'},
                                                  {id: 1, type: 1, name: 'کوچک'},
                                              ]}  */

                                        data={this.state.listImage}
                                        refreshing={false}

                                        onRefresh={() => {
                                            this.props.callserviceActionRefresh();

                                            this.setState({
                                                    listImage: []
                                                },

                                                () => {
                                                    this.getData()
                                                }
                                            )

                                        }}
                                        renderItem={(itemChild) => {
                                            let r = "select" + itemChild.index;

                                            let check = (this.state[r] === itemChild.index);
                                            //  let img = 'pathImage' + itemChild.index;
                                            let img = itemChild.item.path ? itemChild.item.path : itemChild.item.Address
                                            let selectItems = 'select' + itemChild.index;
                                            let Documents = this.getNameDocuments(itemChild.item.CategoryType.value);

                                            // this.setState({
                                            //     typeDocuments: itemChild.item.value
                                            // })
                                            return <View
                                                onPress={() => {


                                                }}
                                                style={{
                                                    width: "98%",
                                                    // height: moderateScale(140),
                                                    //  flex: 1,
                                                    //     flexDirection: 'row',
                                                    marginHorizontal: moderateScale(3),
                                                    marginBottom: moderateScale(4),
                                                    borderRadius: moderateScale(6),
                                                    borderColor: Colors.light,
                                                    backgroundColor: Colors.white,
                                                    borderWidth: moderateScale(1),
                                                    alignSelf: 'center',
                                                    overflow: 'hidden'
                                                }}>
                                                {/*    <View style={{
                                            flex: .2,
                                            backgroundColor: Colors.light,
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            <HMTextView
                                                numberOfLines={1}
                                                // type={"bold"}
                                                text={itemChild.item.name}
                                                //   text={"dgdf"}
                                                style={{
                                                    fontSize: moderateScale(11),
                                                    color: Colors.blackLight,
                                                    //  textAlign: "right",
                                                }}/>
                                        </View>*/}

                                                <View style={{
                                                    flex: 1, flexDirection: 'row'
                                                }}>
                                                    <View
                                                        style={{
                                                            width: moderateScale(120),
                                                            height: moderateScale(120),
                                                            alignItems: 'center', justifyContent: 'center',
                                                        }}>

                                                        {
                                                            // this.state.ShowImage ?

                                                            <View
                                                                style={{
                                                                    position: 'relative',
                                                                    //backgroundColor: '#eeba0d',
                                                                    width: '100%',
                                                                    height: '100%'
                                                                }}>

                                                                {
                                                             /*       Platform.OS === "web" ?
                                                                        <Image
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "100%",
                                                                                resizeMode: 'contain',
                                                                                backgroundColor: Colors.black
                                                                            }}
                                                                            //source={{uri: 'https://poponik.com/wp-content/uploads/2018/09/Black-Rose-00.jpg'}}
                                                                            source={{uri: img}}
                                                                        />
                                                                        :*/
                                                                        <HMLightbox uri={img}/>

                                                                }

                                                                {
                                                                    // this.state.isLoadingUpload ?
                                                                    //     <View
                                                                    //
                                                                    //
                                                                    //         style={{
                                                                    //             width: moderateScale(24),
                                                                    //             height: moderateScale(24),
                                                                    //            // backgroundColor: '#ee005b',
                                                                    //             position: 'absolute',
                                                                    //             //borderRadius: moderateScale(12),
                                                                    //             margin: moderateScale(2),
                                                                    //             top: 0,
                                                                    //             left: 0,
                                                                    //             alignItems: 'center',
                                                                    //             justifyContent: 'center'
                                                                    //         }}>
                                                                    //         <ActivityIndicator color={Colors.colorPrimary}
                                                                    //                            size={"large"}/>
                                                                    //
                                                                    //     </View>
                                                                    //     :
                                                                    //
                                                                    // <TouchableOpacity
                                                                    //     disabled={!itemChild.item.AbilityDelete}
                                                                    //     onPress={() => {
                                                                    //         itemChild.item.AbilityDelete ? this.removeFile(itemChild) : null;
                                                                    //         //this.setState({ShowImage: false})
                                                                    //         // this.state.listImage.splice(itemChild.index, 1)
                                                                    //         // this.setState({
                                                                    //         //     pathImage: null,
                                                                    //         //     [r]: -1
                                                                    //         // })
                                                                    //         // this.onShow("SelectModal")
                                                                    //     }}
                                                                    //
                                                                    //     style={{
                                                                    //         width: moderateScale(24),
                                                                    //         height: moderateScale(24),
                                                                    //         backgroundColor: itemChild.item.AbilityDelete ? '#ee005b' : Colors.green,
                                                                    //         position: 'absolute',
                                                                    //         borderRadius: moderateScale(12),
                                                                    //         margin: moderateScale(2),
                                                                    //         top: 0,
                                                                    //         left: 0,
                                                                    //         alignItems: 'center',
                                                                    //         justifyContent: 'center'
                                                                    //     }}>
                                                                    //     <Icon
                                                                    //         name={itemChild.item.AbilityDelete ? "remove" : 'checkmark'}
                                                                    //
                                                                    //
                                                                    //         style={{
                                                                    //             textAlign: 'center',
                                                                    //             //alignSelf: 'flex-end',
                                                                    //             color: Colors.white,
                                                                    //             // width: moderateScale(32),
                                                                    //             // height: moderateScale(32),
                                                                    //             fontSize: moderateScale(20)
                                                                    //         }}/>
                                                                    // </TouchableOpacity>


                                                                }
                                                            </View>


                                                        }


                                                    </View>

                                                    <View style={{flex: 1, padding: moderateScale(2)}}>

                                                        <View style={{
                                                            flex: 1,
                                                            flexDirection: 'row'
                                                        }}>

                                                            <HMTextView
                                                                //type={"bold"}
                                                                text={"بارگزار کننده : "}
                                                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                                style={{
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(14),
                                                                    //   marginEnd: moderateScale(10),

                                                                }}/>
                                                            <HMTextView
                                                                //type={"bold"}
                                                                text={itemChild.item.opName}
                                                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                                style={{
                                                                    color: Colors.colorDark,
                                                                    fontSize: moderateScale(13),
                                                                    //   marginEnd: moderateScale(10),

                                                                }}/>
                                                        </View>
                                                        <View
                                                            style={{
                                                                flex: 1,
                                                                flexDirection: 'row'
                                                            }}>

                                                            <HMTextView
                                                                //type={"bold"}
                                                                text={"تاريخ بارگزاري : "}
                                                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                                style={{
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(14),
                                                                    //   marginEnd: moderateScale(10),

                                                                }}/>
                                                            <HMTextView
                                                                //type={"bold"}
                                                                text={itemChild.item.Date}
                                                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                                style={{
                                                                    color: Colors.colorDark,
                                                                    fontSize: moderateScale(13),
                                                                    //   marginEnd: moderateScale(10),

                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            flex: 1,
                                                            flexDirection: 'row'
                                                        }}>

                                                            <HMTextView
                                                                //type={"bold"}
                                                                text={"تاييد کننده : "}
                                                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                                style={{
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(14),
                                                                    //   marginEnd: moderateScale(10),

                                                                }}/>
                                                            <HMTextView
                                                                //type={"bold"}
                                                                text={itemChild.item.confirmOpName}
                                                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                                style={{
                                                                    color: itemChild.item.confirmColor ? itemChild.item.confirmColor : Colors.colorDark,
                                                                    fontSize: moderateScale(13),
                                                                    //   marginEnd: moderateScale(10),

                                                                }}/>
                                                        </View>

                                                        <View style={{
                                                            flex: 1,
                                                            flexDirection: 'row'
                                                        }}>

                                                            <HMTextView
                                                                //type={"bold"}
                                                                text={"تاريخ تایید : "}
                                                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                                style={{
                                                                    color: Colors.blackLight,
                                                                    fontSize: moderateScale(14),
                                                                    //   marginEnd: moderateScale(10),

                                                                }}/>
                                                            <HMTextView
                                                                //type={"bold"}
                                                                text={itemChild.item.ConfirmDate}
                                                                //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                                style={{
                                                                    color: itemChild.item.confirmColor ? itemChild.item.confirmColor : Colors.colorDark,
                                                                    fontSize: moderateScale(13),
                                                                    //   marginEnd: moderateScale(10),

                                                                }}/>
                                                        </View>

                                                    </View>
                                                </View>
                                                <View style={{
                                                    width: '100%',
                                                    height: moderateScale(1),
                                                    backgroundColor: Colors.light,
                                                    marginVertical: moderateScale(2)
                                                }}/>
                                                {/*<View style={{flex:.2,alignItems:'center',justifyContent:'center'}}>*/}
                                                {/*<HMTextView*/}
                                                {/*//type={"bold"}*/}
                                                {/*text={i18n.t('constant.Remove')}*/}
                                                {/*//   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}*/}

                                                {/*style={{*/}
                                                {/*color: Colors.red,*/}
                                                {/*fontSize: moderateScale(12),*/}
                                                {/*//   marginEnd: moderateScale(10),*/}

                                                {/*}}/>*/}
                                                {/*</View>*/}
                                                <View
                                                    style={{
                                                        width: '100%',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        padding: moderateScale(2)
                                                    }}>

                                                    <View style={{
                                                        width: moderateScale(120),
                                                        paddingHorizontal: moderateScale(4)
                                                    }}>
                                                        <HMTextView
                                                            //type={"bold"}
                                                            text={"نوع مدرک : "}
                                                            //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                            style={{
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(14),
                                                                //   marginEnd: moderateScale(10),

                                                            }}/>
                                                    </View>
                                                    <View style={{flex: 1,}}>
                                                        <HMSelectInput
                                                            onValueChange={(value,itemInput, index, indexParent, itemParent) => {
                                                                this.setState({
                                                                        typeDocuments: value
                                                                    },
                                                                    () => {
                                                                        if (value != null && value != Documents.value)
                                                                            this.editFile(indexParent, itemParent, index, value);

                                                                    })
                                                            }}
                                                            error={this.state.errorSelectInput}

                                                            //  requestServerRetry={container.getServerTypeDocuments}
                                                            requestServer={() => {
                                                            }}
                                                            //  loading={this.state.isLoadingSelectInput}
                                                            value={itemChild.item.MadrakType}
                                                            index={itemChild.index}
                                                            indexParent={itemChild.index}
                                                            itemParent={itemChild.item}
                                                            itemSelectInput={itemChild.item.CategoryType}
                                                            //  value={"ghjghhg"}
                                                            // text={i18n.t('constant.AccountType')}
                                                            // options={options}
                                                            options={this.props.TypeDocumentsList}

                                                            styleRoot={{
                                                                width: '100%'
                                                            }}
                                                        />
                                                    </View>


                                                </View>
                                            </View>
                                        }
                                        }


                                    />
                                    :
                                    <View style={{
                                        flex: 1,
                                        alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        <HMTextView type={"bold"}
                                                    text={i18n.t('constant.UploadDocumentsPhotoFormat')}
                                            //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                    style={{
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(16),
                                                        //   marginEnd: moderateScale(10),

                                                    }}/>
                                        <TouchableOpacity style={{
                                            backgroundColor: Colors.colorSecondPrimary,
                                            width: "85%",
                                            height: moderateScale(40),
                                            alignItems: "center",
                                            justifyContent: "center",
                                            alignSelf: 'center',
                                            marginTop: moderateScale(14),
                                            borderRadius: moderateScale(2),
                                            marginEnd: moderateScale(10)
                                            //  marginHorizontal:moderateScale(10)
                                            // borderRadius:moderateScale(2)
                                        }}
                                                          onPress={() => {
                                                              this.selectImages()
                                                          }}

                                        >
                                            <View style={{
                                                flexDirection: "row",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <HMTextView type={"bold"}
                                                            text={i18n.t('constant.AddPhoto')}
                                                    //  text={"افزودن عکس"}

                                                            style={{
                                                                color: "white",
                                                                fontSize: moderateScale(14),
                                                                //   marginEnd: moderateScale(10),

                                                            }}/>

                                            </View>
                                        </TouchableOpacity>
                                    </View>
                            }

                            {
                                this.state.listImage.length > 0 ?
                                    <View style={{
                                        flexDirection: 'row',
                                        position: 'absolute',
                                        bottom: 0,
                                        left: 0,
                                        margin: moderateScale(10),
                                    }}>
                                        <TouchableOpacity
                                            style={{
                                                backgroundColor: Colors.colorSecondPrimary,

                                                width: moderateScale(42),
                                                height: moderateScale(42),
                                                alignItems: "center",
                                                justifyContent: "center",
                                                //  alignSelf: 'center',
                                                borderRadius: moderateScale(21),


                                                //  marginHorizontal:moderateScale(10)
                                                // borderRadius:moderateScale(2)
                                            }}
                                            onPress={() => {
                                                this.selectImages()
                                            }}

                                        >
                                            <View style={{
                                                flexDirection: "row", alignItems: "center", justifyContent: "center",


                                            }}>
                                                <HMIcon name={"md-add"} style={{
                                                    width: moderateScale(30),
                                                    height: moderateScale(30),
                                                    //  borderRadius:moderateScale(20),
                                                    textAlign: 'center',
                                                    //alignSelf: 'flex-end',
                                                    color: Colors.white,
                                                    //width: moderateScale(32),
                                                    // height: moderateScale(32),
                                                    fontSize: moderateScale(30)
                                                }}/>

                                            </View>
                                        </TouchableOpacity>
                                        <View style={{width: moderateScale(15)}}/>
                                        {/*<TouchableOpacity*/}
                                        {/*style={{*/}
                                        {/*backgroundColor: Colors.colorPrimary,*/}

                                        {/*flex: 1,*/}
                                        {/*// width: moderateScale(40),*/}
                                        {/*height: moderateScale(40),*/}
                                        {/*alignItems: "center",*/}
                                        {/*justifyContent: "center",*/}
                                        {/*borderRadius: moderateScale(4),*/}
                                        {/*//  alignSelf: 'center',// borderRadius: moderateScale(20),*/}

                                        {/*//  marginHorizontal:moderateScale(10)*/}
                                        {/*// borderRadius:moderateScale(2)*/}
                                        {/*}}*/}
                                        {/*onPress={() => {*/}
                                        {/*this.selectImages()*/}
                                        {/*}}*/}

                                        {/*>*/}
                                        {/*<View style={{*/}
                                        {/*flexDirection: "row", alignItems: "center", justifyContent: "center",*/}


                                        {/*}}>*/}
                                        {/*<HMTextView type={"bold"}*/}
                                        {/*text={i18n.t('constant.Upload')}*/}
                                        {/*//   text={"بارگذاری"}*/}

                                        {/*style={{*/}
                                        {/*color: "white",*/}
                                        {/*fontSize: moderateScale(14),*/}
                                        {/*//   marginEnd: moderateScale(10),*/}

                                        {/*}}/>*/}

                                        {/*</View>*/}
                                        {/*</TouchableOpacity>*/}

                                    </View>

                                    :

                                    null
                            }


                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize
                                        // again
                                        onPress={() => {
                                            this.setState({
                                                    isLoadingUpload: false,
                                                    errorUpload: false,
                                                    visibleModal: '',
                                                },
                                                () => {
                                                    this.getData()
                                                }
                                            )
                                            // this.loadingButton.showLoading(false),
                                            //    this.props.callserviceActionRefresh()
                                        }}
                                    />
                                    :
                                    null
                            }
                            {
                                this.props.isLoading || this.state.isLoadingUpload ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }
                            {
                                this.ModalSelectImage()
                            }
                        </View>
                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    getNameDocuments(typeDocuments) {
        //  let idx = this.props.TypeDocumentsList.findIndex(obj => obj.value == this.state.typeDocuments);
        let idx = this.props.TypeDocumentsList.findIndex(obj => obj.value == typeDocuments);
        if (idx !== -1) {
            let r = this.props.TypeDocumentsList[idx]
            return {label: r.label, value: r.value, index: idx}

        }
        else
            return {label: i18n.t('constant.SelectItem'), value: idx, index: idx}

    }

/*    handleUpload(onComplete, onFail) {
        return event => {
            const file = event.target.files[0];
            if (!/^image\//.test(file.type)) {
                const data = {cancelled: false, error: "Not an image."};
                onFail(data);
                return;
            }

            const reader = new FileReader();

            reader.onload = (event) => {


                const image = new Image({
                    source: file, onLoad: (event, uriiii) => {
                        alert("jkdfh")
                        const {width, height} = event.target;
                        const uri = event.target.src;

                        const data = {cancelled: false, uri, width, height};
                        onComplete(data);
                    }
                });

                // const image = new Image();
                image.src = event.target.result;

                image._onLoad
                /!*
                                image._onLoad = (event,uriiii) => {
                                    alert("jkdfh")
                                    const { width, height } = event.target;
                                    const uri = event.target.src;

                                    const data = { cancelled: false, uri, width, height };
                                    onComplete(data);
                                };*!/
            };

            reader.onerror = err => {
                const data = {cancelled: false, error: err};
                onFail(data);
            };

            reader.onabort = err => {
                const data = {cancelled: false, error: err};
                onFail(data);
            };

            reader.readAsDataURL(file);
        };
    }*/

    _handleImage = ({uri}) => {

        this.setState(() => ({uri}));
    };

    _handleFail = ({error}) => {
        console.log(error);
    };

    fileSelect = async event => {
        let image = await Tools.resizeFile(event.target.files[0]);


        this.uploadFile(image, true)
    }

    ModalSelectImage() {
        return (
            <HMModal
                // style={{backgroundColor: Colors.transparent}}
                // position={"center"}
                // ref={"modal"}
                // backdropPressToClose={true}
                // coverScreen={true}
                // swipeToClose={true}
                // backButtonClose={true}
                // isOpen={this.state.visibleModal}
                // onClosed={() => this.setState({visibleModal: false})}

                isVisible={this.state.visibleModal}
                //visible={this.state.visibleModal}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={() => this.setState({visibleModal: false})}
                onBackButtonPress={() => this.setState({visibleModal: false})}

                animationType="slide"
            >


                <View style={{width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center'}}>

                    <View style={{
                        width: '94%',
                        //  justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: Colors.white,
                        marginHorizontal: moderateScale(10),
                        // alignSelf: 'center',

                        // height:typeExport._WIDTH/2.7
                    }}>
                        {
                            Platform.OS === "web" ?
                                <View style={{width: '100%',padding:moderateScale(10)}}>
                                    {/*       <input id="upload_img_btn" type="file" name="image" className="file-upload-native"
                                           accept="image/*"
                                    />*/}
                                    <HMTextView
                                        text={"فایل مورد نظر خود را انتخاب نمایید"}
                                        type={'bold'}
                                        styleRoot={{
                                            //alignSelf: 'center',
                                        }}
                                        style={{
                                            //   alignSelf: 'center',
                                            //  marginRight: moderateScale(6),
                                            // margin: moderateScale(6),
                                            textAlign: 'center',
                                            color: Colors.colorDarkText,
                                            fontSize: moderateScale(13),
                                            marginBottom: moderateScale(10)
                                        }}/>
                                    <label
                                        onChange={this.fileSelect}

                                        // onChange={this.handleUpload(this._handleImage, this._handleFail)}
                                        style={{
                                            flex: 1,
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}>
                                        <input type="file" accept="image/*"/>

                                    </label>
                                </View>
                                :
                                <View style={{width: '100%'}}>
                                    <TouchableOpacity
                                        onPress={() => {
                                            ImagePicker.openCamera(typeExport.optional).then(image => {
                                                this.uploadFile(image);
                                            });
                                        }}
                                        style={{
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: '#eee',
                                            margin: moderateScale(5),
                                            padding: moderateScale(8),
                                            borderRadius: moderateScale(4),

                                        }}>
                                        <HMTextView
                                            text={"گرفتن عکس"}
                                            type={'bold'}
                                            style={{
                                                //   alignSelf: 'center',
                                                //  marginRight: moderateScale(6),
                                                // margin: moderateScale(6),
                                                textAlign: 'center',
                                                color: Colors.colorDarkText,
                                                fontSize: moderateScale(14),
                                            }}/>
                                    </TouchableOpacity>
                                    <TouchableOpacity
                                        onPress={() => {
                                            ImagePicker.openPicker({
                                                width: 1000,
                                                height: 1000,
                                                crop: true,

                                                //   cropping: true
                                            }).then(image => {
                                                // this.state.listImage.push(image)
                                                this.uploadFile(image);


                                            });
                                        }}
                                        style={{
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: '#eee',
                                            padding: moderateScale(8),
                                            margin: moderateScale(5),
                                            borderRadius: moderateScale(4)
                                        }}>
                                        <HMTextView
                                            text={"انتخاب عکس از گالری"}
                                            type={'bold'}
                                            style={{
                                                // alignSelf: 'center',
                                                //  marginRight: moderateScale(6),
                                                // margin: moderateScale(6),
                                                textAlign: 'center',
                                                color: Colors.colorDarkText,
                                                fontSize: moderateScale(14),
                                            }}/>
                                    </TouchableOpacity>
                                </View>
                        }


                    </View>


                </View>
            </HMModal>
        );
    }

    uploadFile(image, web) {


        this.setState({
            //ShowImage:true
            isLoadingUpload: true,
            errorUpload: false,
            visibleModal: '',
            pathImage: image.path
        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.token);
        formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);

        // let DateTime = new Date().getTime()
        // let nameImage = DateTime + '.jpg';
        if (web) {
            formData.append('image0', image, image.name+".JPG");
            /*   formData.append('image' + ii, {
                   uri: image,
                   name: image.name,
                   type: 'image/jpeg'
               });*/
        } else {
            let arr = []
            for (let i = 0; i < 1; i++) {
                let ii = i + 1;
                let DateTime = new Date().getTime()
                let nameImage = DateTime + "_" + ii + '.jpg';
                formData.append('image' + ii, {
                    uri: image.path,
                    name: nameImage,
                    type: 'image/jpeg'
                });

            }
        }

        //   if (image && image !== null) formData.append('image[]', arr);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT_FILE
            }
        };

        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "user/uploadFiles",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

            // onUploadProgress:progressEvent=>{
            // }
            // onUploadProgress: function (progressEvent) {
            // },
        })
     //   axios.post(typeExport._baseUrlSatia + "user/uploadFiles", formData, config)
            .then(async response => {
                let data = response.data;

                // data.status ? this.state.listImage.push(image) : null;

                if (data.status) {
                    this.setState({
                        //ShowImage:true
                        listImage: data.result,
                        //TypeDocumentsList:[],
                        isLoadingUpload: false,
                        errorUpload: !data.status,
                        visibleModal: '',
                        pathImage: image.path
                    })
                }
                else {
                    this.ShowError(image, response)
                }

            }).catch((e) => {
            this.ShowError(image)


            console.log('error', e)
        })
    }

    ShowError(image, response) {
        this.setState({
                //ShowImage:true
                // listImage:  data.status ? data.result : this.state.listImage,
                //TypeDocumentsList:[],
                isLoadingUpload: false,
                errorUpload: true,
                visibleModal: '',
                pathImage: image ? image.path : null
            },
            () => {
                HMAlert(
                    i18n.t('constant.message'),
                    response ? response.data.message : i18n.t('constant.retry'),
                    [
                        {
                            text: i18n.t('constant.ok'), onPress: () => {

                            }


                        },

                    ],
                    {cancelable: true}
                )
            })
    }

    removeFile(item) {


        this.setState({
            //ShowImage:true
            isLoadingUpload: true,
            errorUpload: false,
            visibleModal: '',
            //pathImage: image.path
        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.token);
        formData.append('serial', item.item.Serial);
        formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT
            }
        };

       // axios.post(typeExport._baseUrlSatia + "user/deleteFiles", formData, config)
        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "user/deleteFiles",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
            .then(async response => {
                let data = response.data;

                //  data.status ? this.state.listImage.push(image) : null;
                if (data.status) {
                    let r = "select" + item.index;
                    this.state.listImage.splice(item.index, 1)
                    this.setState({
                        pathImage: null,
                        [r]: -1,
                        isLoadingUpload: false,
                        errorUpload: false,
                        visibleModal: '',
                    })

                }
                else {
                    this.ShowError(null, response)

                }

            }).catch((e) => {
            this.ShowError(null)

            console.log('error', e)
        })
    }

    editFile(index, item, indexCategory, valueCategory) {


        this.setState({
            //ShowImage:true
            isLoadingUpload: true,
            errorUpload: false,
            visibleModal: '',
            //pathImage: image.path
        })


        const formData = new FormData();
        formData.append('lang', i18n.locale);
        formData.append('token', this.props.token);
        formData.append('serial', item.Serial);
        formData.append('MadrakType', valueCategory);
        formData.append('customer', store.getState().reducerSplashSatiaScreen.Account ? JSON.stringify(store.getState().reducerSplashSatiaScreen.Account) : null);

        const config = {
            headers: {
                "Content-Type": "multipart/form-data; charset=utf-8;",
                // 'Content-Type': 'application/json',
                // "Authorization": `Basic ${params.token}`,
                timeout: typeExport._TIMEOUT
            }
        };

     //   axios.post(typeExport._baseUrlSatia + "user/editFile", formData, config)
        axios({
            method: 'post',
            url: typeExport._baseUrlSatia + "user/editFile",
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
            .then(async response => {
                let data = response.data;

                //  data.status ? this.state.listImage.push(image) : null;
                if (data.status) {
                    let r = this.state.listImage;

                    // let idx = r.findIndex(obj => obj.Serial === item.item.Serial);

                    let t = this.props.TypeDocumentsList[indexCategory]
                    if (index > -1) {
                        r[index].CategoryType = t
                    }
                    // let r = "select" + item.index;
                    // this.state.listImage.splice(item.index, 1)
                    this.setState({
                        pathImage: null,
                        listImage: r,
                        isLoadingUpload: false,
                        errorUpload: false,
                        visibleModal: '',
                    })
                }
                else {
                    this.ShowError(null, response)

                }

            }).catch((e) => {

            this.ShowError(null)

            console.log('error', e)
        })
    }

    selectImages() {
        this.setState({
            visibleModal: "selectImage"
        })
    }

}

